// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "assets_js_badLinksDetect_js") return "./js/chunks/9f623137b0c8720e2c93.js";
	if (chunkId === "assets_js_modules_btnClue_js") return "./js/chunks/39f34a0be2055228eec3.js";
	if (chunkId === "assets_js_modules_btnMenu_js") return "./js/chunks/15806628d0ee6d1f8e5a.js";
	if (chunkId === "assets_js_modules_chat_js") return "./js/chunks/28c55c8286a28d6ac797.js";
	if (chunkId === "assets_js_modules_final_js") return "./js/chunks/deb1fc7912d668bbe2eb.js";
	if (chunkId === "assets_js_modules_indicator_js") return "./js/chunks/5efd66d3ac1cd87ca982.js";
	if (chunkId === "assets_js_modules_lottie_js") return "./js/chunks/4595b523787c463635e2.js";
	if (chunkId === "assets_js_modules_messageSlider_js") return "./js/chunks/0dbc6759aeefd8d4e745.js";
	if (chunkId === "assets_js_modules_phase_js") return "./js/chunks/186d932598d1a8c834ce.js";
	if (chunkId === "assets_js_modules_phaseWelcome_js") return "./js/chunks/fa2299b8a7e73cc6a913.js";
	if (chunkId === "assets_js_modules_phaseend_js") return "./js/chunks/e99435c3572b31dae161.js";
	if (chunkId === "assets_js_modules_questionsForm_js") return "./js/chunks/813cb89573992eba8ece.js";
	if (chunkId === "assets_js_modules_questionsSlider_js") return "./js/chunks/d3eecc1017921919da17.js";
	if (chunkId === "assets_js_modules_results_js") return "./js/chunks/18ff767de0aaf7d32ac7.js";
	if (chunkId === "assets_js_modules_timesup_js") return "./js/chunks/8676ff864ecf0da81848.js";
	if (chunkId === "assets_js_modules_tuto_js") return "./js/chunks/f1934dda54d7411a83c7.js";
	if (chunkId === "assets_js_modules_typingText_js") return "./js/chunks/4515f0fbb6cc3fb6e829.js";
	if (chunkId === "assets_js_vendors_lottie_min_js") return "./js/chunks/9dae861608f49e84ffe9.js";
	// return url for filenames based on template
	return undefined;
};